import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Amplify } from "aws-amplify";
import { cognitoConfig } from "./auth/config";
import { isStub } from "./auth/auth-service";
import { routes } from "./App";
import "./fonts.css";
import "./index.css";

if (!isStub) {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: cognitoConfig.userPoolId,
        userPoolClientId: cognitoConfig.userPoolClientId,
      },
    },
  });
}

// Data router (createBrowserRouter + RouterProvider) is required for
// useBlocker to work — needed by ReportReviewPage to guard browser back
// against losing unsaved doctor edits (HH-232 case 4).
const router = createBrowserRouter(routes);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
